export interface ReleaseNoteSection {
  id: string
  title: string
  summary: string
  details: readonly string[]
}

export interface ReleaseNotes {
  version: string
  publishedAt: string
  publishedLabel: string
  title: string
  introduction: string
  sections: readonly ReleaseNoteSection[]
}

// This catalog is the single content source for the title-screen changelog and its unread version.
export const currentReleaseNotes: ReleaseNotes = {
  version: '4.0.0',
  publishedAt: '2026-08-13',
  publishedLabel: '2026.08.13',
  title: '事件三最终版 · 选择之后（4.0.0）',
  introduction: '第三季完整发布。从北岸临时冻结开始，连续经历七十二小时、第一次承诺、旧账中点、信任重排、最终立场和六月三十日表决。所有五条路线、主要结局、关系收束与独立结局档案均已开放。',
  sections: [
    {
      id: 'v400-complete-season-three',
      title: '事件三完整季',
      summary: '八章连续主线，从返校第一日推进至六月三十日季终。',
      details: [
        '序章的四种公开回应会改变七十二小时章节的证据、监督、公开支持或调查入口。',
        '行动方法、长期策略、责任承诺、中点目标与最终立场均在后续章节获得可见回收。',
        '线上已有序章完成档会自动进入“七十二小时”，无需重开事件三。',
      ],
    },
    {
      id: 'v400-endings',
      title: '完整结局与失败余波',
      summary: '五条路线各两种结局，并提供第三道路与被吸收结局。',
      details: [
        '二至六组分别围绕队伍调度、外联名册、成员表决、私人联络与独立席位完成自己的季终行动。',
        '第三道路让责任共享而权力可撤回；高风险的独自否决失败后也有完整余波。',
        '每个结局只由玩家本季的公开选择决定，不由伴侣或旧季结局暗中改写。',
      ],
    },
    {
      id: 'v400-relationships',
      title: '十五种关系状态完整收束',
      summary: '十二位合法伴侣、瓶与真理兼容关系及无伴侣路径均有季终回应。',
      details: [
        '关系可收束为继续同行、暂时分开但互相理解或明确结束；无伴侣路径拥有独立余波。',
        '关系选择会在六月三十日兑现，但不会替代公共主线或主要结局。',
        '结束关系时会明确解除当前伴侣状态，不把决裂伪装成圆满。',
      ],
    },
    {
      id: 'v400-archive',
      title: '第三季独立结局档案',
      summary: '完整通关后生成不可变的三季连续性记录。',
      details: [
        '档案保存主要结局、关系收束、关键承诺和事件二来源血缘。',
        '删除普通事件三进度不会删除已经形成的结局档案。',
        '损坏或缺少关键状态的进度会停在明确隔离页，不会被静默分配到别人的结局。',
      ],
    },
    {
      id: 'v330-season-three-prologue',
      title: '北岸来客',
      summary: '沈知行带着 72 小时临时冻结措施返回 4945 区。',
      details: [
        '五条路线分别面对活动队伍缺人、外交失声、投票失效、外联暴露和独立席位降格。',
        '玩家可以要求证据、附条件接受、公开拒绝，或暂缓表态并调查。',
        '每项回应都有沈知行的直接反馈，并形成下一阶段明确行动目标。',
      ],
    },
    {
      id: 'v330-continuity',
      title: '完整继承事件二结果',
      summary: '路线、结局与关系以快照进入事件三。',
      details: [
        '多个事件二结局并存时由玩家手动选择，系统不会自动指定所谓官方结局。',
        '十二位合法伴侣、瓶与真理兼容关系以及无伴侣状态均有开场承认。',
        '事件三开始后，即使来源档案被删除，已开始的剧情也不会被改写。',
      ],
    },
    {
      id: 'v330-storage',
      title: '事件三独立进度',
      summary: '不升级、不覆盖前两季存档。',
      details: [
        '事件三使用独立进度槽，事件一、事件二和结局档案保持原样。',
        '没有完整事件二结局时，可以在剧透提示后创建明确标记的回顾档。',
        '事件三完整八章现已开放；3.3.0 的序章进度可直接续入“七十二小时”。',
      ],
    },
    {
      id: 'v320-choice-responses',
      title: '选择立即得到回应',
      summary: '二至六组的关键选项不再直接汇入同一段剧情。',
      details: [
        '角色会针对玩家刚才的具体决定，用符合各自口吻的台词直接回应。',
        '截图、站队、权限、战备、分配与合并等选择都有独立反馈。',
        '回应发生在原主要事件之间，不会替换固定历史或跳过原有冲突。',
      ],
    },
    {
      id: 'v320-later-echoes',
      title: '关键决定留下后续回响',
      summary: '早期承诺会在真正付出代价时重新出现。',
      details: [
        '四组开区时定下的分配原则，会在稀有饰品争议中被角色重新追问。',
        '三组的证据、联盟和要塞选择，会改变后续战报与成员回应。',
        '二、五、六组的组织立场和管理决定，也会在下一次危机中留下不同痕迹。',
      ],
    },
    {
      id: 'v320-continuity-fixes',
      title: '修正选择与事实矛盾',
      summary: '拒绝、观察和站队现在会真实改变当下状态。',
      details: [
        '拒绝将进酒转入三组后，不再播放已经接纳的边界对白。',
        '四组选择先观察 takemehand 时，会等满一天后才正式加入。',
        '五组的原则中立、支持一组和保持沉默拥有不同的即时与后续结果。',
      ],
    },
    {
      id: 'v320-summer-bridge',
      title: '暑假事件进入事件二',
      summary: '八月初的拒收、退游、道歉与组织重组不再只停留在资料里。',
      details: [
        '苏铭申请被拒、温陷退游、夏娜公开道歉与一组成员分流被整理为连续桥接剧情。',
        '事件二会使用云梦仙踪、虚妄月华、镜花水月与心之所向等重组后的组织名称。',
        '铁碎牙与困醒分别在四组、五组季终承担首领确认，不改变原路线与结局编号。',
      ],
    },
    {
      id: 'v320-district-archive',
      title: '完整区史与成员名册',
      summary: '资料文件夹中的 53 个有效文件全部获得可追溯的游戏落点。',
      details: [
        '八月时间线和 20 张聊天记录进入区史档案，原截图由脱敏摘要卡替代，不公开聊天界面。',
        '32 张人物图片进入成员名册；没有事件证据的人只记录身份，不强行编写支线或关系。',
        '两张疑似真人照片改用全新虚构二次元头像，避免公开可识别的真人形象。',
      ],
    },
    {
      id: 'v320-compatibility',
      title: '原进度继续兼容',
      summary: '不改主要事件、结局编号、CG与存档结构。',
      details: [
        '旧存档停在共享节点时仍按原路线继续，不要求重新开档。',
        '所有原选项效果、固定日期、历史事件、关系结局和组织结局继续保留。',
        '旧档会在进入八月桥接后补齐重组状态，收藏、离线缓存与主线传承继续沿用原数据。',
        '自动验收覆盖完整剧情图、章节回放、存档迁移、移动端和主线传承。',
      ],
    },
  ],
}
